<template>
    <div class="admin_main_wrapper">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <b-list-group class="organization_list">
            <b-list-group-item v-for="(item, index) in organizations" :key="index" class="oraganization_item">
                <div class="control-panel">
                    <div @click.stop="onOpenOrganizationSettings(item)" class="control-panel-item">
                        <i class="fas fa-cog"></i>
                    </div>

                    <div @click.stop="onDeleteOrganization(item)" class="control-panel-item">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                </div>

                <div class="organization_name">{{item.official_name}}</div>
                <div class="oraganization_multiple">Multiple: {{item.multiple}}</div>
                <div class="mb-0"> <span class="oraganization_UID">UID:</span> {{item.guid}}</div>
                <div class="organization_invites">
                    Invites:
                    <div class="organization_invites__email" v-for="(item, index) in item.invites" :key="index">
                        {{item.email}},
                    </div>
                </div>
                <div class="organization_managers">
                    Managers:
                    <div class="organization_info__wrapper">
                        <div class="organization_info" v-for="(item, index) in item.managers" :key="index">
                            ({{item.email}}) ({{item.first_name}} {{item.last_name}})
                        </div>
                    </div>
                </div>
                <div v-if="item.all_places"
                     class="place_content"
                     @click="item.all_places.length == 0 ?  this.placesInfoModal == false : onOpenPlacesInfo(item)">
                    <div>
                        <div class="organization_place--name">Places count: {{item.all_places.length}}</div>
                    </div>
                </div>
                <div v-if="item.owner" class="place_content">
                    <div class="place_content-info">
                        <div><span class="place_content-owner">Owner:</span> {{item.owner.first_name}}
                            {{item.owner.last_name}}
                        </div>
                        <div>({{item.owner.guid}})</div>
                    </div>
                </div>
                <div
                        @click="onShowQuestionsClick(item)"
                        class="place_content">
                    <div>
                        <div class="organization_place--name">Questions</div>
                    </div>
                </div>
            </b-list-group-item>
            <infinite-loading  :identifier="infinity" @infinite="getOrganizations">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
            </infinite-loading>
        </b-list-group>
        <!-- Places info modal -->
        <b-modal v-model="placesInfoModal" content-class="custom-modal">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="close"></span>
            </template>
            <div v-if="selectedPlaces">
                <div v-for="(item, index) in selectedPlaces.all_places" :key="index" class="selected-info">
                    <img class="place_image" :src="item.preview">
                    <div class="selected-info__content">
                        <div><span class="selected-info__title">Name:</span>{{item.name}}</div>
                        <div><span class="selected-info__title">UID:</span> {{item.uid}}</div>
                        <div><span class="selected-info__title">Adress:</span> {{item.address}}</div>
                        <div><span class="selected-info__title">Org: </span> {{item.organization}}</div>
                        <div class="selected-info__managers">
                            Managers:
                            <div v-for="(managers, index) in item.managers" :key="index">
                                {{managers.email}} ({{managers.first_name}} {{managers.last_name}})
                            </div>
                        </div>
                        <div class="selected-info__links">
                            Link:
                            <div v-for="(social, index) in item.links" :key="index">
                                {{social.link}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="placesInfoModal = false">
                    {{ translate('Close') }}
                </b-button>
            </template>
        </b-modal>
        <!-- questions of org modal -->
        <b-modal content-class="custom-modal" v-model="questionsByOrgModal.show">
            <template v-slot:modal-header="{ close }">
                <span @click="onCloseQuestionsDialogClick" class="close-icon"></span>
            </template>
            <b-form-checkbox v-model="questionsByOrgModal.selectAll">
                <span>{{translate('bulkPlacementPopupSelectAll')}}</span>
            </b-form-checkbox>
            <div v-if="questionsByOrgModal.questions">
                <div :key="index" class="selected-info" v-for="(item, index) in questionsByOrgModal.questions">
                    <b-form-checkbox v-model="item.selected">
                        <div class="selected-info__content">
                            <span><b>{{item.text}}</b> ({{item.optional}})</span>
                            <div>{{item.uid}}</div>
                            <div>{{item.place_name}}</div>
                        </div>
                    </b-form-checkbox>
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button @click="onCloseQuestionsDialogClick" class="secondary" variant="default">
                    {{ translate('Close') }}
                </b-button>
                <b-button @click="onGeneratePdfClick" variant="primary">
                    Generate pdf
                </b-button>
            </template>
        </b-modal>
        <!-- Setting organization modal -->
        <b-modal v-model="organizationSettingsModal" content-class="custom-modal organization-settings">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="cancelOrganizationModal(close)"></span>
            </template>

            <div v-if="selectedOrganization">
                <h5 class="mb-4">{{ selectedOrganization.official_name }}</h5>

                <b-input-group class="mt-3 justify-content-between align-items-center">
              <span class="h6" v-if="selectedOrganization.owner">
                {{selectedOrganization.owner.guid}}
              </span>
                    <b-form-input v-else v-model="organizationConnect.owner"
                                  placeholder="Enter owner ID"></b-form-input>

                    <b-input-group-append>
                        <b-button
                                variant="danger"
                                v-if="selectedOrganization.owner"
                                :disabled="loadingOwner"
                                @click="removeOwnerFromOrganization"
                        >
                            <b-spinner small v-if="loadingOwner"></b-spinner>
                            {{ translate('admin_RemoveItem', ['admin_Owner']) }}
                        </b-button>

                        <b-button variant="primary" v-else :disabled="loadingOwner" @click="addOwnerToOrganization">
                            <b-spinner small v-if="loadingOwner"></b-spinner>
                            {{ translate('admin_AddItem', [translate('admin_Owner')]) }}
                        </b-button>
                    </b-input-group-append>
                </b-input-group>

                <b-input-group class="mt-3 justify-content-between align-items-center">
                    <span class="h6" v-if="selectedOrganization.place">{{selectedOrganization.place.uid}}</span>
                    <b-form-input v-else v-model="organizationConnect.place"
                                  placeholder="Enter place ID"></b-form-input>

                    <b-input-group-append>
                        <b-button
                                variant="danger"
                                v-if="selectedOrganization.place"
                                :disabled="loadingPlace"
                                @click="removePlaceFromOrganization"
                        >
                            <b-spinner small v-if="loadingPlace"></b-spinner>
                            {{ translate('admin_RemoveItem', ['Place']) }}
                        </b-button>

                        <b-button variant="primary" v-else :disabled="loadingPlace" @click="addPlaceToOrganization">
                            <b-spinner small v-if="loadingPlace"></b-spinner>
                            {{ translate('admin_AddItem', ['Place']) }}
                        </b-button>

                    </b-input-group-append>
                </b-input-group>
                <b-input-group class="mt-3 justify-content-between align-items-center">
                    <b-form-input v-model="organizationConnect.orgManager"
                                  placeholder="Enter org manager email"></b-form-input>
                    <b-input-group-append>
                        <b-button variant="primary" :disabled="loadingOrgManager" @click="addManagerToOrganization">
                            <b-spinner small v-if="loadingOrgManager"></b-spinner>
                            {{ translate('admin_AddItem', ['']) }}
                        </b-button>
                    </b-input-group-append>
                </b-input-group>

                <b-form-group class="mt-3">
                    <b-form-input
                            id="input-formatter"
                            v-model="selectedOrganization.contact_email"
                            placeholder="Enter your email"
                    ></b-form-input>
                </b-form-group>

                <b-form-group class="mt-3">
                    <b-form-input
                            id="tooltip-button-variant"
                            v-model="selectedOrganization.phone"
                            placeholder="Enter your phone"
                    ></b-form-input>
                </b-form-group>

                <b-tooltip target="tooltip-button-variant" variant="info">Ex: +38 (050) 777-77-77</b-tooltip>

                <b-form-group class="mt-3">
                    <b-form-input
                            id="input-formatter"
                            v-model="selectedOrganization.address"
                            placeholder="Enter your address"
                    ></b-form-input>
                </b-form-group>

                <b-form-group class="mt-3">
                    <b-form-input
                            id="input-formatter"
                            v-model="selectedOrganization.website"
                            placeholder="Enter your website url"
                    ></b-form-input>
                </b-form-group>
            </div>
            <div
                    v-else-if="spinner"
                    class="info-status"
            >
                <b-spinner small></b-spinner>
            </div>
            <div
                    v-else
                    class="info-status"
            >
                {{translate('NoData')}}
            </div>

            <template v-slot:modal-footer>
                <b-button variant="default" class="secondary" @click="cancelOrganizationModal">
                    {{ translate('Cancel') }}
                </b-button>

                <b-button variant="primary" :disabled="loadingUpdate" @click="onUpdateOgranization">
                    {{ translate('Save') }}
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from "vuex";
    import InfiniteLoading from "vue-infinite-loading";
    import errorMixin from '@/mixins/errorMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import adminPageMixin from "@/mixins/adminPageMixin";


    export default {
        name: "Organization",

        components: {
            InfiniteLoading,
            customModalDialog,
        },
        mixins: [errorMixin, adminPageMixin,],
        data() {
            return {
                loading: false,
                page: 1,
                spinner: true,
                customModalSettings: {},
                updateOrganizationList: false,
                selectedOrganization: null,
                organizationConnect: {
                    owner: '',
                    place: '',
                    orgManager: '',
                },
                organizationSettingsModal: false,
                organizations: [],
                customSidebarSettings: {},
                placesInfoModal: false,
                selectedPlaces: null,
                loadingPlace: false,
                loadingOwner: false,
                loadingAction: false,
                loadingUpdate: false,
                loadingDelete: false,
                loadingOrgManager: false,
                questionsByOrgModal: {
                    orgGuid: null,
                    show: false,
                    questions: [],
                    selectAll: false,
                },
            }
        },

        props: ['infinity', 'questionsForPdfReady', 'organizationsQuestionsForPdf'],

        watch: {
            infinity(val) {
                this.page = 1
            },
            'questionsByOrgModal.selectAll': function (newVal, oldVal) {
                this.questionsByOrgModal.questions.forEach((item) => {
                    item.selected = newVal
                })
            },
        },
        mounted() {
            this.initAdminPage()
        },

        methods: {
            ...mapActions({
                fetchOrganizationsAction: 'organization/fetchOrganizations',
                addPlaceToOrganizationAction: 'organization/addPlaceToOrganization',
                removeOwnerFromOrganizationAction: 'organization/removeOwnerFromOrganization',
                addOwnerToOrganizationAction: 'organization/addOwnerToOrganization',
                removePlaceFromOrganizationAction: 'organization/removePlaceFromOrganization',
                deleteOrganization: 'organization/deleteOrganization',
                upadteOrganization: 'organization/upadteOrganization',
                fetchQuestionsByOrganization: 'organization/fetchQuestionsByOrganization',
                sendInviteAction: 'organization/sendInvite',
            }),
            onOpenPlacesInfo(item) {
                this.selectedPlaces = JSON.parse(JSON.stringify(item))
                this.placesInfoModal = true;
            },

            onOpenOrganizationSettings(item) {
                this.selectedOrganization = JSON.parse(JSON.stringify(item))
                this.organizationSettingsModal = true
            },

            async onShowQuestionsClick(item) {
                this.loading = true
                try {
                    const response = await this.fetchQuestionsByOrganization({organizationGuid: item.guid});
                    if (response.success) {
                        if (response.qrs.length == 0) {
                            this.showErrorModal('This organization doesn\'t have questions', {title: 'Oops'})
                        } else {
                            this.questionsByOrgModal.questions = response.qrs;
                            this.questionsByOrgModal.orgGuid = item.guid
                            this.questionsByOrgModal.show = true
                        }
                    } else {
                        this.showErrorModal(response.error.message)
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

            async onGeneratePdfClick() {
                let guids = this.questionsByOrgModal.questions.filter((item) => item.selected).map((item) => item.uid)
                this.hideQuestionsDialogAndClear()
                this.questionsForPdfReady(guids)
            },

            onCloseQuestionsDialogClick() {
                this.hideQuestionsDialogAndClear()
            },

            hideQuestionsDialogAndClear() {
                this.questionsByOrgModal.show = false
                this.questionsByOrgModal.selectAll = false
                this.questionsByOrgModal.questions = []
                this.questionsByOrgModal.orgGuid = null
            },

            onDeleteOrganization(item) {
                console.log(item.guid)
                this.customModalSettings = {
                    message: this.translate('admin_deleteOrganization', [item.official_name]),
                    onOkHandler: this.deleteOrganizationAction.bind(null, item),
                    showCancelButton: true,
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },
            async deleteOrganizationAction(organization) {
                try {
                    await this.deleteOrganization(organization.guid)
                    const index = this.organizations.findIndex(item => item === organization)
                    this.organizations.splice(index, 1)

                    this.customModalSettings = {
                        message: this.translate('admin_successMessageRemoveOrganization'),
                        okButtonText: this.translate('yes'),
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

            cancelOrganizationModal(closeFn) {
                if (typeof closeFn === "function") closeFn()
                this.organizationSettingsModal = false

                if (this.updateOrganizationList) {
                    this.getOrganizations()
                }

                this.updateOrganizationList = false
                this.selectedOrganization = null
            },
            async getOrganizations(stateInf) {
                this.spinner = true
                try {
                    const response = await this.fetchOrganizationsAction({
                        page: this.page
                    });
                    if (response.success) {
                        if(this.page == 1) {
                            this.organizations = []
                        }
                        this.page += 1
                        response.organizations.forEach((item) => {
                            this.organizations.push(item)
                        })
                        if (stateInf) {
                            if (response.organizations.length === 10) {
                                stateInf.loaded();
                            } else {
                                stateInf.complete();
                            }
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingAction = false
                }
            },
            async addOwnerToOrganization() {
                try {
                    const responce = await this.addOwnerToOrganizationAction({
                        organizationID: this.selectedOrganization.guid,
                        userID: this.organizationConnect.owner
                    })
                    if (responce.success) {
                        this.updateOrganizationList = true

                        this.customModalSettings = {
                            message: this.translate('admin_successMessageAddOwner'),
                            icon: 'ic_allow.svg'
                        }
                        this.selectedOrganization.owner = {
                            guid: this.organizationConnect.owner
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },
            async removeOwnerFromOrganization() {
                try {
                    this.loadingOwner = true
                    const responce = await this.removeOwnerFromOrganizationAction({
                        organizationID: this.selectedOrganization.guid,
                        userID: this.selectedOrganization.owner.guid
                    })
                    if (responce.success) {
                        this.updateOrganizationList = true

                        this.customModalSettings = {
                            message: this.translate('admin_successMessageRemoveOwner'),
                            icon: 'ic_allow.svg'
                        }

                        this.organizationConnect.owner = ''
                        this.selectedOrganization.owner = null
                    } else {
                        this.showErrorModal()
                    }
                } catch (error) {
                    if (error.data.error.code === 1123) {
                        this.showErrorModal(error.data.error.message)
                    }
                } finally {
                    this.loadingOwner = false
                }
            },
            async addManagerToOrganization() {
                try {
                    this.loadingOrgManager = true
                    const response = await this.sendInviteAction({
                        body: {emails: [this.organizationConnect.orgManager]},
                        orgUid: this.selectedOrganization.guid
                    })
                    this.updateOrganizationList = true
                    this.customModalSettings = {
                        message: 'Org manager added successfully',
                        icon: 'ic_allow.svg'
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingOrgManager = false
                }
            },
            async addPlaceToOrganization() {
                try {
                    this.loadingPlace = true
                    const responce = await this.addPlaceToOrganizationAction({
                        organizationID: this.selectedOrganization.guid,
                        placeID: this.organizationConnect.place
                    })
                    if (responce.success) {
                        this.updateOrganizationList = true
                        this.customModalSettings = {
                            message: this.translate('admin_successMessageAddPlace'),
                            icon: 'ic_allow.svg'
                        }
                        this.selectedOrganization.place = {
                            uid: this.organizationConnect.place
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingPlace = false
                }
            },
            async onUpdateOgranization() {
                try {
                    this.loadingUpdate = true
                    await this.upadteOrganization({
                        organizationID: this.selectedOrganization.guid,
                        organization: this.selectedOrganization
                    })
                    this.customModalSettings = {
                        message: this.translate('admin_successMessageSaveOrganization'),
                        icon: 'ic_allow.svg'
                    }
                    const index = this.organizations.findIndex(item => item.guid === this.selectedOrganization.guid)
                    this.organizations[index] = JSON.parse(JSON.stringify(this.selectedOrganization))
                    this.organizationSettingsModal = false

                    if (this.updateOrganizationList) {
                        this.getOrganizations()
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingUpdate = false
                }
            },
            async removePlaceFromOrganization() {
                try {
                    this.loadingPlace = true
                    const responce = await this.removePlaceFromOrganizationAction({
                        organizationID: this.selectedOrganization.guid,
                        placeID: this.organizationConnect.place
                    })
                    if (responce.success) {
                        this.updateOrganizationList = true
                        this.selectedOrganization.place = null
                        this.organizationConnect.place = ''
                        this.customModalSettings = {
                            message: this.translate('admin_successMessageRemovePlace'),
                            icon: 'ic_allow.svg'
                        }
                    } else {
                        this.showErrorModal()
                    }
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                } finally {
                    this.loadingPlace = false
                }
            },
        }
    }
</script>

<style scoped>
    .organization_list {
        max-height: calc(100vh - 62px);
    }

    .organization_list {
        overflow: auto;
        margin-bottom: 0;
        width: 100%;
        min-width: 100%;
    }

    .oraganization_item {
        display: table;
        width: 100%;
        min-width: 100%;
        flex-direction: column;
        align-items: flex-start;
        font-size: .8em;
    }

    .oraganization_item > .place_content {
        display: block;
        align-items: center;
        flex-direction: row !important;
    }

    .oraganization_item .organization_name {
        font-weight: 900;
        padding-right: 50px;
    }

    .oraganization_multiple {
        font-weight: 900;
    }
    .oraganization_UID {
        font-weight: 900;
    }

    .organization_invites {
        display: flex;
        font-weight: 900;
    }

    .organization_invites__email {
        padding-left: 8px;
    }

    .organization_managers {
        display: flex;
        font-weight: 900;
    }

    .organization_info {
        margin-left: 8px;
    }

    .selected-info {
        display: flex;
        text-align: left;
        border-bottom: 1px solid gray;
        margin-bottom: 5px;
    }

    .selected-info__content {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
    }

    .selected-info__title {
        font-weight: 700;
        padding-right: 5px;
    }

    .oraganization_item .place_content {
        display: flex;
    }
    .place_content-info {
        display: flex;
        flex-direction: row;
    }
    .place_content-owner {
        font-weight: 900;
    }

    .place_image {
        width: 70px !important;
        height: 70px !important;
        margin-bottom: 5px;
    }

    .oraganization_item .organization_place--name {
        font-weight: 900;
        margin-right: 1em;
        cursor: pointer;
        border-bottom: 1px solid black;
    }

    @media screen and (max-width: 1000px) {
        .oraganization_item .organization_name {
            margin-bottom: .5em;
        }

        .oraganization_item .place_img {
            margin-left: 0.5em;
        }

        .oraganization_item .place_content {
            flex-direction: column;
            margin-left: 0;
            margin-top: 1em;
        }
    }

    @media screen and (max-width: 505px) {
        .organization_invites {
            display: flex;
            flex-direction: column;
        }
    }

    .organization-settings .btn {
        padding: 8px 12px;
    }

    .organization-settings .h6 {
        font-size: 15px;
        margin-bottom: 0;
    }

    @media screen and (max-width: 1000px) {
        .organization-settings .form-control {
            width: 100%;
        }

        .organization-settings .input-group-append,
        .organization-settings .input-group-append .btn {
            width: 100%;
        }
    }
</style>